import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft, LogOut, BookOpen, ArrowRight } from 'lucide-react';

const SESSION_KEY = 'admin_authenticated';

const playbooks = [
  {
    id: 'amazon-ads',
    title: 'Amazon Ads Master Playbook',
    description: 'Playbook interactif complet pour optimiser vos campagnes Amazon Ads (SP, SB, SD)',
    path: '/admin/playbooks/amazon-ads'
  }
];

export default function AdminPlaybooks() {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY) !== 'true') {
      navigate('/admin');
    }
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.removeItem(SESSION_KEY);
    navigate('/admin');
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Playbooks - Admin - Cosmos Wave</title>
      </Helmet>
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8">
          <div className="flex justify-between items-center mb-8">
            <div>
              <Button variant="ghost" asChild className="mb-4">
                <Link to="/admin/cx-lab">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Retour au CX Lab
                </Link>
              </Button>
              <h1 className="text-3xl font-bold mb-2">Playbooks</h1>
              <p className="text-muted-foreground">
                Guides stratégiques et playbooks Amazon
              </p>
            </div>
            <Button variant="outline" onClick={handleLogout}>
              <LogOut className="w-4 h-4 mr-2" />
              Déconnexion
            </Button>
          </div>

          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {playbooks.map((playbook) => (
              <Card key={playbook.id} className="hover:shadow-lg transition-shadow">
                <CardHeader>
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                    <BookOpen className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle>{playbook.title}</CardTitle>
                  <CardDescription>{playbook.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <Button asChild className="w-full group">
                    <Link to={playbook.path}>
                      Ouvrir le playbook
                      <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                    </Link>
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
